export default "__VITE_ASSET__BTQJNN5O__";